import { memo } from "react";

import { Extension } from "@codemirror/state";
import { ReactCodeMirrorRef, StateField } from "@uiw/react-codemirror";

import {
  CodeInput,
  CodeInputProps,
} from "src/base-components/CodeInput/CodeInput";
import { NodeEditorCompletionContext } from "src/nodeEditor/NodeEditor";

export type AutocompleteCodeInputProps = Omit<
  CodeInputProps,
  "completionExtension"
> & { isFieldInLoopIteration?: boolean };

/**
 * This field is present to determine if the input is corresponding to a loop iteration
 */
export const isFieldInLoopIteration = StateField.define({
  create: () => {
    return true;
  },
  update: (value) => value,
});

const getCompletionExtension = (
  props: AutocompleteCodeInputProps,
  defaultCompletion: Extension | undefined,
) => {
  if (props.plaintext || props.prefix === "$" || props.readOnly) {
    return undefined;
  }

  if (props.isFieldInLoopIteration) {
    return defaultCompletion === undefined
      ? undefined
      : [defaultCompletion, isFieldInLoopIteration];
  }

  return defaultCompletion;
};

export const AutocompleteCodeInput: React.FC<
  AutocompleteCodeInputProps & { ref?: React.Ref<ReactCodeMirrorRef> }
> = memo(({ ref, ...props }) => {
  return (
    <NodeEditorCompletionContext.Consumer>
      {({ defaultCompletion }) => {
        return (
          <CodeInput
            {...props}
            ref={ref}
            completionExtension={getCompletionExtension(
              props,
              defaultCompletion,
            )}
          />
        );
      }}
    </NodeEditorCompletionContext.Consumer>
  );
});
